import { render, staticRenderFns } from "./testBiletView.vue?vue&type=template&id=7008c634&"
import script from "./testBiletView.vue?vue&type=script&lang=js&"
export * from "./testBiletView.vue?vue&type=script&lang=js&"
import style0 from "./testBiletView.vue?vue&type=style&index=0&id=7008c634&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports